var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.authenticated
    ? _c(
        "div",
        {
          staticClass: "app-wrapper",
          style: _vm.brandColours,
          on: {
            dragover: function ($event) {
              $event.preventDefault()
            },
            drop: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c("header-phone"),
          _vm._v(" "),
          _c("header-logo"),
          _vm._v(" "),
          _c("thread-chat-drawer"),
          _vm._v(" "),
          _c("div", { staticClass: "dashboard" }, [
            _c(
              "div",
              { staticClass: "dashboard-container" },
              [
                _c("navigation", {
                  ref: "navigation",
                  staticClass: "dashboard-nav",
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.notLoading,
                        expression: "notLoading",
                      },
                    ],
                    staticClass: "dashboard-main",
                    style:
                      _vm.$route.name !== "talent.profile.show.interests" &&
                      _vm.$route.name !== "profile.show.interests" &&
                      _vm.$route.name !== "profile.show.career" &&
                      _vm.$route.name !== "talent.profile.show.career"
                        ? "overflow: hidden"
                        : null,
                  },
                  [_c("router-view")],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "footer", attrs: { id: "footer" } },
            [
              _c(_vm.$vlastMode ? "vlast-footer" : "marketplace-footer", {
                tag: "component",
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }